import { Flex } from '@aloft/toolkit-sui'
import { ZipCodeMultiplier } from './ZipCodeMultiplier.tsx';
import { CustomMultiplier } from './CustomMultiplier.tsx';

export const CostMultiplier = () => (
  <Flex flexDirection="column" gap="1.5rem">
    <ZipCodeMultiplier />
    <CustomMultiplier />
  </Flex>
)
